import React, { useContext } from 'react';
import { Button } from 'antd';
import calendarPng from 'assets/images/calendar.png';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { OBIE_LINK } from './insurance.constant';

interface Props {
  visible: boolean;
  setVisible: Function;
  closeTask?: Function;
}

const ModalFinish = ({ visible, setVisible, closeTask }: Props) => {

  return (
    <ModalEndSubmit
      visible={visible}
      setVisible={setVisible}
      buttonAction={{ hidden: true }}
      modal={{
        title: 'Get your insurance quote directly from Obie',
        description: (
          <h4 className="h4 h4-w4">
            You can switch back to your own agent by reopening this task and choosing another option.
          </h4>
        )
      }}
      className=""
      icon={calendarPng}
      buttonSubmit={
        <Button
          htmlType="submit"
          className="button button-modal-ok"
          onClick={() => {
            window.open(OBIE_LINK, '_blank');
            
            setVisible(false);
            if(closeTask)
              closeTask();
          }}
        >
          Get quote from Obie
        </Button>
      }
    />
  );
};
export default ModalFinish;
